import {
    dateObjectFromTimestamp,
    getSpanishLocaleDateFormat,
    getAssignmentClassByDate,
    isSettingChecked,
    getFormattedHour
} from '@/helpers.js'

// ======================== Getters definitions ========================
export default {
    getHomePageFormattedCourses (state) {
        // console.log('getHomePageFormattedCourses')
        if (!state.coursesList || !state.coursesList.length) {
            return null
        }

        var semesters = {
            'Semestre I': [],
            'Semestre II': [],
            'Semestre III': [],
            'Semestre IV': [],
            'Semestre V': [],
            'Semestre VI': [],
            'Semestre VII': [],
            'Semestre VIII': [],
            'Semestre IX': [],
            'Semestre X': [],
            'Electivas': [],
            'Otra': []
        }

        var homeCourses = {}
        state.careerList.forEach(value => {
            homeCourses[value] = JSON.parse(JSON.stringify(semesters))
        })

        state.coursesList.map(
            (course) => course.careers.map(
                (career) => {
                    let classificationName = ''
                    if (course.type === 'Obligatoria') {
                        classificationName = course.classifications[0].name
                    } else if (course.type === 'Otra') {
                        classificationName = 'Otra'
                    } else {
                        classificationName = 'Electivas'
                    }
                    homeCourses[career.name][classificationName].push({
                        code: course.code,
                        name: course.name,
                        credit_units: course.credit_units,
                        type: course.type,
                        requirements: course.requirements,
                        sites: course.sites
                    })
                }
            )
        )
        return homeCourses
    },
    getCourseByCode: (state) => (courseCode) => {
        return state.coursesList.find(course => course.code === courseCode)
    },
    getUserRelatedRecentSitesBySemester (state) {
        // Return an object of semester objects with 2 properties: academicPeriod of the semester itself
        // and sites which is an array of the sites that belong to that semester. The keys of the main object
        // are the semesterIds
        if (state.currentPossibleSemesters.length && state.userData.relatedRecentSites.length) {
            var semesterIds = state.currentPossibleSemesters.map((semester) => semester.id.toString())
            var recentSitesBySemester = {}
            for (const semesterIdString of semesterIds) {
                recentSitesBySemester[semesterIdString] = {
                    academicPeriod: state.currentPossibleSemesters.find(semester => semester.id.toString() === semesterIdString).academic_period,
                    sites: state.userData.relatedRecentSites.filter(recentSite => {
                        return recentSite.semesterId.toString() === semesterIdString
                    })
                }
                if (recentSitesBySemester[semesterIdString].sites.length <= 0) {
                    delete recentSitesBySemester[semesterIdString]
                }
            }
            return recentSitesBySemester
        }

        return null
    },

    // User Credentials
    isUserAuthenticated (state) {
        return state.userToken !== ''
    },
    areUserDetailsLoaded (state) {
        return state.userData.id !== null
    },
    getUserDisplayName (state) {
        return state.userData.displayName
    },
    isUserAdmin (state) {
        return state.userData.role >= state.userRoles.administrator
    },
    isUserCoordInCurrentSite (state, getters) {
        return (getters.getUserRoleInActiveSite === state.userRoles.coordinator)
    },
    isUserCoordOrBetter (state, getters) {
        return (getters.getUserRoleInActiveSite >= state.userRoles.coordinator) || getters.isUserAdmin
    },
    isUserProfInCurrentSite (state, getters) {
        return (getters.getUserRoleInActiveSite === state.userRoles.professor)
    },
    isUserProfOrBetter (state, getters) {
        return (getters.getUserRoleInActiveSite >= state.userRoles.professor) || getters.isUserAdmin
    },
    isUserStudenTeacherInCurrentSite (state, getters) {
        return (getters.getUserRoleInActiveSite === state.userRoles.studentTeacher)
    },
    isUserStudenTeacherOrBetter (state, getters) {
        return (getters.getUserRoleInActiveSite >= state.userRoles.studentTeacher) || getters.isUserAdmin
    },
    isUserStudentInCurrentSite (state, getters) {
        return (getters.getUserRoleInActiveSite === state.userRoles.student)
    },
    isUserStudentOrBetter (state, getters) {
        return (getters.getUserRoleInActiveSite >= state.userRoles.student) || getters.isUserAdmin
    },
    isUserTeachingStaff (state) {
        // Does the user has the global role of StudentTeacher, Professor or Coordinator?
        const role = state.userData.role
        return (role > state.userRoles.student) && (role < state.userRoles.administrator)
    },
    getUserEmailPreferences (state) {
        return {
            notice: isSettingChecked(state.notifications.NOTICE, state.userData.emailSettings),
            file: isSettingChecked(state.notifications.FILE, state.userData.emailSettings),
            forum: isSettingChecked(state.notifications.FORUM, state.userData.emailSettings),
            comment: isSettingChecked(state.notifications.COMMENT, state.userData.emailSettings),
            assignment: isSettingChecked(state.notifications.ASSIGNMENT, state.userData.emailSettings),
            evaluation: isSettingChecked(state.notifications.EVALUATION, state.userData.emailSettings),
            events: isSettingChecked(state.notifications.EVENT, state.userData.emailSettings)
        }
    },

    // AdminPage getters
    getAdminPageFormattedCourses (state) {
        if (!state.coursesList || !state.coursesList.length) {
            return null
        }

        var adminCourses = {}
        state.careerList.forEach(value => {
            adminCourses[value] = []
        })

        state.coursesList.map(
            (course) => course.careers.map(
                (career) => {
                    adminCourses[career.name].push({
                        id: course.id,
                        code: course.code,
                        name: course.name,
                        creditUnits: course.credit_units,
                        type: course.type,
                        requirements: course.requirements,
                        sites: course.sites
                    })
                }
            )
        )

        return adminCourses
    },

    // ////////////////////////////////////////////////////////////////
    //                        SitePage getters                       //
    // ////////////////////////////////////////////////////////////////

    getActiveSiteIdentifiers (state) {
        if (state.activeSite) {
            return {
                courseCode: state.activeSite.course.code,
                academicPeriod: state.activeSite.semester.academic_period
            }
        }
        return null
    },
    getUserRoleInActiveSite (state) {
        if (state.userData.relatedSites.length && state.activeSite) {
            console.log({ activeSiteId: state.activeSite.id })
            console.log({ relatedSites: state.userData.relatedSites })
            let currentSite = state.userData.relatedSites.filter(site => {
                return site.id === state.activeSite.id
            }).pop()
            console.log({ currentSite: currentSite })
            if (currentSite) {
                return currentSite.role
            }
        }
        return -1
    },
    getActiveSiteObjectives (state) {
        // Return an array of formatted objective objects sorted by created_at date
        if (state.activeSite && state.activeSite.objectives.length) {
            var objectivesList = []
            state.activeSite.objectives.map(objective => {
                objectivesList.push({
                    id: objective.id,
                    description: objective.description,
                    createdAt: objective.created_at
                })
            })
            return objectivesList.sort(function (a, b) {
                var dateA = dateObjectFromTimestamp(a.createdAt)
                var dateB = dateObjectFromTimestamp(b.createdAt)
                return dateA - dateB // sort by date ascending
            })
        }
        return null
    },
    getActiveSiteBibliographies (state) {
        // Return an array of formatted bibliography objects sorted by created_at date
        if (state.activeSite && state.activeSite.bibliographies.length) {
            var bibliographiesList = []
            state.activeSite.bibliographies.map(bibliography => {
                bibliographiesList.push({
                    id: bibliography.id,
                    title: bibliography.title,
                    authors: bibliography.authors,
                    description: bibliography.description,
                    createdAt: bibliography.created_at
                })
            })
            return bibliographiesList.sort(function (a, b) {
                var dateA = dateObjectFromTimestamp(a.createdAt)
                var dateB = dateObjectFromTimestamp(b.createdAt)
                return dateA - dateB // sort by date ascending
            })
        }
        return null
    },
    getActiveSiteThematicContents (state) {
        // Return an array of formatted thematic content objects sorted by created_at date
        if (state.activeSite && state.activeSite.thematicContents.length) {
            var contentsList = []
            state.activeSite.thematicContents.map(content => {
                contentsList.push({
                    id: content.id,
                    title: content.title,
                    description: content.description,
                    createdAt: content.created_at
                })
            })
            return contentsList.sort(function (a, b) {
                var dateA = dateObjectFromTimestamp(a.createdAt)
                var dateB = dateObjectFromTimestamp(b.createdAt)
                return dateA - dateB // sort by date ascending
            })
        }
        return null
    },
    getActiveSiteTeachingStaffOptions (state) {
        // Return an array of formatted teaching staff objects of joined professors and teacherStudents
        // to be used as options in a b-input-select component
        var teachingStaffList = []
        if (state.activeSite) {
            if (state.activeSite.professors.length) {
                state.activeSite.professors.forEach((prof) => {
                    let name = `[${prof.professor.user.identity_card}] ${prof.professor.user.lastname}, ${prof.professor.user.name}`
                    teachingStaffList.push({
                        value: prof.professor_id,
                        text: name
                    })
                })
            }

            if (state.activeSite.studentTeachers.length) {
                state.activeSite.studentTeachers.forEach((stTeacher) => {
                    let name = `[${stTeacher.student.user.identity_card}] ${stTeacher.student.user.lastname}, ${stTeacher.student.user.name}`
                    teachingStaffList.push({
                        value: stTeacher.student_id,
                        text: name
                    })
                })
            }
            if (teachingStaffList.length) {
                return teachingStaffList
            }
        }
        return null
    },
    getActiveSiteNewsConfig (state) {
        // Return an object with the active site news config
        if (state.activeSite) {
            return {
                displayTwitterFeed: state.activeSite.config.notices_type,
                twitterId: state.activeSite.config.notices_twitter
            }
        }
        return null
    },
    getActiveSiteNewsList (state) {
        // Return an array of formatted news objects
        if (state.activeSite && state.activeSite.notices && state.activeSite.notices.length) {
            var newsList = []
            state.activeSite.notices.map(notice => {
                newsList.push({
                    id: notice.id,
                    title: notice.title,
                    body: notice.notice,
                    latestUpdateDate: getSpanishLocaleDateFormat(notice.updated_at),
                    authorName: `${notice.user.lastname.split(' ').pop()}, ${notice.user.name.split(' ').pop()}`
                })
            })
            return newsList
        }
        return null
    },
    getActiveSiteProfessors (state) {
        if (state.activeSite && state.activeSite.professors.length) {
            return state.activeSite.professors.map((professor) => {
                return {
                    id: professor.id,
                    identityCardNumber: professor.professor.user.identity_card,
                    name: `${professor.professor.user.lastname}, ${professor.professor.user.name}`,
                    email: professor.email,
                    position: state.activeSite.coordinator.id === professor.professor_id ? 'Coordinador' : 'Docente'
                }
            })
        }
        return null
    },
    getActiveSiteStudentTeachers (state) {
        if (state.activeSite && state.activeSite.studentTeachers.length) {
            return state.activeSite.studentTeachers.map((studentTeacher) => {
                return {
                    id: studentTeacher.id,
                    identityCardNumber: studentTeacher.student.user.identity_card,
                    name: `${studentTeacher.student.user.lastname}, ${studentTeacher.student.user.name}`,
                    email: studentTeacher.email,
                    position: studentTeacher.type
                }
            })
        }
        return null
    },
    getActiveSiteTimetablesByType (state) {
        // Return an object of site timetables by schedule types with each timetableRow already formatted.
        if (state.activeSite && state.activeSite.schedule.length) {
            var formattedTimetableRows = state.activeSite.schedule.map((schedule) => {
                return {
                    id: schedule.id,
                    activityType: schedule.type,
                    instructor: {
                        id: schedule.user.id,
                        name: `${schedule.user.lastname}, ${schedule.user.name}`
                    },
                    section: {
                        id: schedule.section_id,
                        name: schedule.section.name
                    },
                    weekday: schedule.day,
                    startHour: schedule.initial_hour,
                    endHour: schedule.final_hour,
                    timeslot: `${getFormattedHour(schedule.initial_hour)} - ${getFormattedHour(schedule.final_hour)}`,
                    classroom: schedule.classroom,
                    scheduleOnly: schedule.schedule_only
                }
            })
            var timetableTypes = formattedTimetableRows.map((timetableRow) => timetableRow.activityType)
            timetableTypes = [...new Set(timetableTypes)].sort((a, b) => b.localeCompare(a)) // Inverse Alpha sorting order
            var timetablesByTypes = {}
            for (const key of timetableTypes) {
                timetablesByTypes[key] = formattedTimetableRows.filter(timetableRow => {
                    return timetableRow.activityType === key
                })
            }
            return timetablesByTypes
        }
        return null
    },
    getActiveSiteSectionOptions (state) {
        // Return an array of the site sections as options to be used in a b-input-select element.
        // The sections are extracted from the timetables (if not schedule_only)
        if (state.activeSite && state.activeSite.schedule.length) {
            var siteSections = state.activeSite.schedule
                .filter(timetable => timetable.schedule_only === false)
                .map(timetable => {
                    return {
                        value: timetable.section.id,
                        text: timetable.section.name
                    }
                })
            // Remove and order duplicated section objects
            siteSections = siteSections.filter((section, index, self) => {
                return self.findIndex(s => s.value === section.value) === index
            }).sort((a, b) => (a.text > b.text) ? 1 : -1)

            return siteSections
        }
        return null
    },
    getActiveSiteStudentsBySection (state, getters) {
        // Return an object of site students grouped by sections with each student instance already formatted.
        // The sections are extracted form the schedules (if not schedule_only)
        if (state.activeSite && state.activeSiteStudents && getters.getActiveSiteSectionOptions) {
            var formattedStudentRows = state.activeSiteStudents.map((student) => {
                return {
                    id: student.id,
                    idCardNumber: student.student.user.identity_card,
                    lastName: student.student.user.lastname,
                    name: student.student.user.name,
                    email: student.student.user.email,
                    section: student.section.name
                }
            })
            var studentSections = getters.getActiveSiteSectionOptions.map(section => section.text)
            var siteStudentsbySection = {}
            for (const key of studentSections) {
                siteStudentsbySection[key] = formattedStudentRows.filter(student => student.section === key)
            }
            return siteStudentsbySection
        }
        return null
    },
    getActiveSiteEvaluations (state) {
        // Return an array of propperly formatted active site evaluation objects.
        if (state.activeSite && state.activeSite.evaluations && state.activeSite.evaluations.length) {
            var percentageTotal = 0
            var formattedEvaluationRows = state.activeSite.evaluations.sort((a, b) => {
                let dateA = dateObjectFromTimestamp(a.initial_date)
                let dateB = dateObjectFromTimestamp(b.initial_date)
                return dateA > dateB ? 1 : -1
            }).map((evaluation) => {
                let evalStartDate = `${getSpanishLocaleDateFormat(evaluation.initial_date)}`
                let evalEndDate = `${getSpanishLocaleDateFormat(evaluation.final_date)}`
                if (evalStartDate !== evalEndDate) {
                    evalStartDate = `${evalStartDate} - ${evalEndDate}`
                }
                percentageTotal += evaluation.value
                return {
                    id: evaluation.id,
                    name: evaluation.name,
                    activityType: evaluation.type,
                    value: evaluation.value.toFixed(2),
                    startDate: evaluation.initial_date.slice(0, 10),
                    startDateString: evaluation.initial_date,
                    endDate: evaluation.final_date.slice(0, 10),
                    endDateString: evaluation.final_date,
                    date: evalStartDate
                }
            })
            // Add Total Row
            formattedEvaluationRows.push({
                id: -1,
                name: 'Total',
                activityType: '',
                value: percentageTotal.toFixed(2),
                startDate: '',
                endDate: '',
                date: ''
            })
            return formattedEvaluationRows
        }
        return null
    },
    canEditSurvey (state) {
        if (state.selectedSurveyObject && state.selectedSurveyObject.studentSurveyCount > 0) {
            return false
        }
        return true
    },
    getActiveSiteAssignments (state) {
        // Return an object of site assignments already formatted.
        if (state.activeSite &&
            state.serverTime &&
            state.activeSiteAssignments &&
            state.activeSiteAssignments.length) {
            var formattedAssignments = state.activeSiteAssignments.map((assignment) => {
                return {
                    id: assignment.id,
                    name: assignment.name,
                    deadlineDate: assignment.delivery_date.slice(0, 10),
                    displayDeadlineDate: getSpanishLocaleDateFormat(assignment.delivery_date),
                    maxSize: assignment.max_size,
                    class: getAssignmentClassByDate(assignment.delivery_date, state.serverTime)
                }
            })
            return formattedAssignments
        }
        return null
    },
    getActiveSiteScheduleEvents (state, getters) {
        var events = []
        // Add to the events array all available site evaluations
        if (getters.getActiveSiteEvaluations) {
            getters.getActiveSiteEvaluations.forEach(evaluation => {
                if (evaluation.id !== -1) { // Avoid using the total row
                    events.push({
                        id: `eva-${evaluation.id}`,
                        title: evaluation.name,
                        description: `${evaluation.value}%`,
                        startDate: dateObjectFromTimestamp(evaluation.startDateString),
                        endDate: dateObjectFromTimestamp(evaluation.endDateString),
                        classes: 'evaluation-event'
                    })
                }
            })
        }

        // Add to the events array all available site assignment
        if (state.activeSite && state.activeSite.assignments.length) {
            state.activeSite.assignments.forEach(assignment => {
                events.push({
                    id: `asgnmt-${assignment.id}`,
                    title: assignment.name,
                    startDate: dateObjectFromTimestamp(assignment.delivery_date),
                    endDate: dateObjectFromTimestamp(assignment.delivery_date),
                    classes: 'assignment-event'
                })
            })
        }

        // Add to the events array all available site scheduled events
        if (state.activeSite && state.activeSite.planifications.length) {
            state.activeSite.planifications.forEach(event => {
                events.push({
                    id: `reg-${event.id}`,
                    eventId: event.id,
                    title: event.name,
                    description: event.description,
                    startDate: dateObjectFromTimestamp(event.initial_date),
                    endDate: dateObjectFromTimestamp(event.final_date),
                    classes: 'regular-event'
                })
            })
        }

        return events.sort((a, b) => a.startDate > b.startDate ? 1 : -1)
    },
    getActiveSiteForumPosts (state) {
        // Return a list of site forum posts objects already formatted.
        if (state.activeSite &&
            state.activeSiteForumPosts &&
            state.activeSiteForumPosts.length) {
            var formattedForums = state.activeSiteForumPosts.map((forumPost) => {
                return {
                    id: forumPost.id,
                    title: forumPost.title,
                    body: forumPost.description,
                    authorName: `${forumPost.user.name} ${forumPost.user.lastname}`,
                    authorId: forumPost.user_id,
                    latestUpdateDate: getSpanishLocaleDateFormat(forumPost.updated_at)
                }
            })
            return formattedForums
        }
        return null
    },
    getActiveForumPostComments (state) {
        // Return a list of forum post comments associated with the selected forum post already formatted.
        if (state.activeSite &&
            state.selectedForumPostObject &&
            state.selectedForumPostComments &&
            state.selectedForumPostComments.length) {
            var formattedComments = state.selectedForumPostComments.map((comment) => {
                return {
                    id: comment.id,
                    body: comment.comment,
                    authorName: `${comment.user.name} ${comment.user.lastname}`,
                    authorId: comment.user_id,
                    latestUpdateDate: getSpanishLocaleDateFormat(comment.updated_at)
                }
            })
            return formattedComments
        }
        return null
    },
    getActiveSiteDownloadsByType (state) {
        // Return a formatted object of site downloadable files grouped by type.
        if (state.activeSite && state.activeSite.files && state.activeSite.files.length) {
            var formattedFileDownloads = state.activeSite.files.map((file) => {
                return {
                    id: file.id,
                    name: file.name,
                    sizeKB: (file.size / (1024)).toFixed(2), // Size in kilobytes
                    clicks: file.times_downloaded,
                    type: file.type,
                    downloadUrl: `${process.env.VUE_APP_API_URL}/sites/${state.activeSite.id}/files/${file.id}`
                }
            })
            var donwloadTypes = formattedFileDownloads.map((file) => file.type)
            donwloadTypes = [...new Set(donwloadTypes)].sort((a, b) => a.localeCompare(b)) // Alpha sorting order
            var fileDownloadsByType = {}
            for (const key of donwloadTypes) {
                fileDownloadsByType[key] = formattedFileDownloads.filter(file => file.type === key)
            }
            return fileDownloadsByType
        }
        return null
    },
    getActiveSiteFormattedLinks (state) {
        // Return an array of formatted site link objects.
        if (state.activeSite && state.activeSite.links.length) {
            var formattedLinks = state.activeSite.links.map((link) => {
                return {
                    id: link.id,
                    name: link.name,
                    url: link.url
                }
            })
            return formattedLinks
        }
        return null
    },
    getActiveSiteFormattedVideos (state) {
        // Return an array of formatted site video objects.
        if (state.activeSite && state.activeSite.videos && state.activeSite.videos.length) {
            var formattedVideos = state.activeSite.videos.map((video) => {
                return {
                    id: video.id,
                    name: video.name,
                    url: video.url,
                    clicks: video.times_watched
                }
            })
            return formattedVideos
        }
        return null
    },
    getActiveSiteLogs (state) {
        // Return an object of site logs already formatted.
        if (state.activeSite && state.activeSiteLogs && state.activeSiteLogs.length) {
            var formattedLogsRows = state.activeSiteLogs.map((log) => {
                return {
                    id: log.id,
                    ip: log.ip,
                    description: log.description,
                    created_at: `${getSpanishLocaleDateFormat(log.created_at)}`
                }
            })
            return formattedLogsRows
        }
        return null
    },
    getSingleStudentGrades (state) {
        if (state.singleStudentGrades && state.singleStudentGrades.length) {
            var totalPercentage = 0
            var totalGrade = 0
            var formattedGrades = state.singleStudentGrades.map((grade) => {
                totalPercentage += grade.percentage
                totalGrade += (grade.grade * grade.percentage * 0.01) // (Max total grade of 20)
                return {
                    id: grade.id,
                    name: grade.name,
                    percentage: grade.percentage.toFixed(2),
                    grade: grade.grade.toFixed(2)
                }
            })
            // Add Total Row
            formattedGrades.push({
                id: -1,
                name: 'Total',
                percentage: totalPercentage.toFixed(2),
                grade: totalGrade.toFixed(2)
            })

            return formattedGrades
        }
        return null
    },
    getActiveSiteGrades (state, getters) {
        if (state.activeSiteGrades && getters.getActiveSiteEvaluations && Object.keys(state.activeSiteGrades).length) {
            var sections = Object.keys(state.activeSiteGrades)
            var formattedGrades = {}
            sections.forEach(section => {
                formattedGrades[section] = state.activeSiteGrades[section].map(student => {
                    var formattedStudent = {
                        identity_card: student.identity_card,
                        name: `${student.lastname}, ${student.name}`
                    }
                    student.grades.map(grade => {
                        formattedStudent[`[${grade.evaluation_id}]${grade.evaluation_name}`] = {
                            grade_id: grade.grade_id,
                            grade_value: grade.grade_value,
                            evaluation_id: grade.evaluation_id,
                            old_grade: JSON.parse(JSON.stringify(grade.grade_value)),
                            updating: false
                        }
                    })
                    return formattedStudent
                })
            })

            return formattedGrades
        }
        return null
    },
    getActiveSitePreviousSemesters (state) {
        // Return an array of the previous semesters objects already formatted.
        if (state.activeSite && state.activeSitePreviousSemestersSites) {
            // Take the first 10 available site news if they exist
            var previousSitesList = []
            state.activeSitePreviousSemestersSites.map(previousSite => {
                previousSitesList.push({
                    id: previousSite.id,
                    route: {
                        name: 'site',
                        params: {
                            courseCode: state.activeSite.course.code,
                            academicPeriod: previousSite.semester.academic_period
                        }
                    },
                    academicPeriod: previousSite.semester.academic_period,
                    coordinatorName: `${previousSite.coordinator.user.lastname}, ${previousSite.coordinator.user.name}`
                })
            })
            return previousSitesList
        }
        return null
    }
}
